import { render, staticRenderFns } from "./UploadZone.vue?vue&type=template&id=5a37b0c1&scoped=true&"
import script from "./UploadZone.vue?vue&type=script&lang=js&"
export * from "./UploadZone.vue?vue&type=script&lang=js&"
import style0 from "./UploadZone.vue?vue&type=style&index=0&id=5a37b0c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a37b0c1",
  null
  
)

export default component.exports